module.exports = __webpack_public_path__ + "media/gai01.ed203966.mp3";